import './components/ellipsis';
import './components/splide';
import './components/popup';
import './components/totop';
import './components/header';
import './components/countdown';
import './components/rating';
import './components/filter';
import './components/blog';
import './components/cart';
import './components/profile';
import './fe';
import './be';